import { Record } from 'react-admin';
import { APP_ITEM_SELECTED_BACKGROUND_COLOR_ON_LIST } from '../theme';

export const rowStyle = (record: Record | undefined, index: number, resourceSelected: Record | undefined) => {
    return {
        backgroundColor: resourceSelected?.id === record?.id ? APP_ITEM_SELECTED_BACKGROUND_COLOR_ON_LIST : 'white',
    };
};
